import { RouteNames } from '../../types/RouteNames'

export const authRouteNames = {
  home: '/',
  login: '/login',
  access: '/access',
  signup: '/signup',
  insertPin: '/insert-your-pin',
  insertPinLogin: '/insert-your-pin-login',
  forgotPassword: '/forgot-my-password',
  changePassword: '/change-password',
  changePasswordSuccessful: '/change-password-successful',
  selectRecover: '/recover',
  forgotLogin: '/forgot-my-login',
  recoverLoginSuccesFul: '/recover-login-successful'
} as const satisfies RouteNames
